export const bluetoothDeviceReducer = (state = null, action) => {
    switch (action.type) {
      case 'SET_BLUETOOTH_DEVICE':
        return action.payload;
      default:
        return state;
    }
  };
